import styled from "styled-components";

import "../../../../../../GlobalStyles/Font.css"

export const ContainerAge = styled.div`
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    @media (min-width: 428px) {
      margin-top: 30px;
    }
`;

export const TextAge = styled.p`
  font-size: 16px;
  font-family: Exo2 Light;
  width: 209px;

  &.error-animation-input {
    color: #e63946;
  }

  @media (min-width: 428px) {
    width: 316px;
    font-size: 20px;
  }

  @media (min-width: 744px) {
    width: 249px;
  }

  @media (min-width: 1024px) {
    width: 249px;
  }

  @media (min-width: 1440px) {
    width: 350px;
  }
`;

export const ContainerPravicy = styled.div`
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    @media (min-width: 428px) {
      margin-top: 30px;
    }
`;

export const TextPravicy = styled.span`
  font-size: 16px;
  font-family: Exo2 Light;
  width: 209px;

  &.error-animation-input {
    color: #e63946;
  }

  @media (min-width: 428px) {
    width: 338px;
    font-size: 20px;
  }

  @media (min-width: 744px) {
    width: 312px;
  }

  @media (min-width: 1024px) {
    width: 209px;
  }

  @media (min-width: 1440px) {
    width: 365px;
  }
`;

export const TextPravicyLink = styled.a`
  color: #1a50c6;
`;

export const CheckboxAge = styled.span<{ checked: boolean }>`
  background: ${({ checked }) => (checked ? "#1a50c6" : "#d9d9d9")};
  transition: 500ms cubic-bezier(0.61, 0, 0.51, 1);
  border-radius: 5px;
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  &.error-animation-input {
    color: #e63946;
    border: 3px solid #e63946;
    border-radius: 5px;
  }
`;

export const CheckboxPrivacy = styled.span<{ checked: boolean }>`
  background: ${({ checked }) => (checked ? "#1a50c6" : "#d9d9d9")};
  transition: 500ms cubic-bezier(0.61, 0, 0.51, 1);
  border-radius: 5px;
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  &.error-animation-input {
    color: #e63946;
    border: 3px solid #e63946;
    border-radius: 5px;
  }
`;

export const CheckIcon = styled.svg<{ checked: boolean }>`
  width: 20px;
  height: 20px;
  fill: ${({ checked }) => (checked ? "#d9d9d9" : "#fff")};
`;

